module.exports = __webpack_public_path__ + "static/media/hand.e387cfee.jpg";